export default __webpack_public_path__ + "static/media/one.d140a18b.jpeg";